/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Categories as PlatformCategories } from 'models/business/Platform';
import Ad, { Statuses } from 'models/business/Ad';
import googleWhiteIcon from 'assets/GoogleAdsLogo_45.png';
import facebookWhiteIcon from 'assets/FBLogo_45.png';
import Styles from './index.module.css';

const StatusMessages = {
  [Statuses.Incomplete]: '廣告未上線',
  [Statuses.Archive]: '封存廣告',
  [Statuses.Pending]: '等待上線',
  [Statuses.Online]: '廣告進行中',
  [Statuses.Stopped]: '廣告已停止',
};

const StatusColors = {
  [Statuses.Incomplete]: '#F28379',
  [Statuses.Archive]: '#8b8e91',
  [Statuses.Pending]: '#F8BD39',
  [Statuses.Online]: '#0CB381',
  [Statuses.Stopped]: '#F28379',
};

function AdSummary({
  ad,
  isCollapsed,
}) {
  const [statusColor, setStatusColor] = useState(StatusColors[ad.status]);
  // const [outdatedStatus, setOutdatedStatus] = useState(false);
  useEffect(() => {
    setStatusColor(StatusColors[ad.status]);
    // setOutdatedStatus((new Date()).getTime() >= ad.startDate.getTime());
    // (new Date()).getTime() >= ad.startDate.getTime() && setStatusColor(StatusColors[Statuses.Online]);
  }, [ad]);
  const iconRender = () => {
    if (ad.isFacebook) return <img src={facebookWhiteIcon} alt="Facebook" />;
    if (ad.isGoogle) return <img src={googleWhiteIcon} alt="Google" />;
    return <></>;
  };

  const isCollapsedRender = (
    <>
      {/* <div className={Styles.contentIcon}> */}
      <div className={Styles.headerContainer}>
        <div className={Styles.headerIcon}>
          {iconRender()}
        </div>
        <div className={Styles.headerType}>
          <div className={Styles.boldText15}>
            {ad.platform === PlatformCategories.Google && 'PMAX' }
            {ad.platform === PlatformCategories.FacebookCarousel && '輪播' }
            {ad.platform === PlatformCategories.FacebookFeatured && '精選輯' }
            {ad.platform === PlatformCategories.FacebookReferral && '導流' }
            {ad.platform === PlatformCategories.FacebookImpression && '曝光' }
          </div>
        </div>
      </div>
      <div className={Styles.headerName}>
        <div className={Styles.boldText15}>
          {ad.name}
        </div>
      </div>
      {/* <div className={Styles.contentName}>
        <div className={Styles.tag}>
          名字
        </div>
        <div className={Styles.boldText15}>
          {ad.name}
        </div>
      </div> */}
      {/* <div className={Styles.contentAdState}>
        <div className={Styles.tag}>
          單元狀態：
        </div>
        <div className={Styles.adStateText} style={{ color: statusColor || '#ffffff' }}>
          {StatusMessages[ad.status] || '未知'}
        </div>
      </div>
      <div className={Styles.headerPadding} /> */}
    </>
  );

  const isNotCollapsedRender = (
    <>
      <div className={Styles.headerContainer}>
        <div className={Styles.headerIcon}>
          {iconRender()}
        </div>
        <div className={Styles.adType}>
          {/* <div className={Styles.tag}>
            名字
          </div> */}
          <div className={Styles.boldText15}>
            {ad.platform === PlatformCategories.Google && 'PMAX' }
            {ad.platform === PlatformCategories.FacebookCarousel && '輪播' }
            {ad.platform === PlatformCategories.FacebookFeatured && '精選輯' }
            {ad.platform === PlatformCategories.FacebookReferral && '導流' }
            {ad.platform === PlatformCategories.FacebookImpression && '曝光' }
          </div>
        </div>
      </div>
      <div className={Styles.headerName}>
        <div className={Styles.boldText15}>
          {ad.name}
        </div>
      </div>
      <div className={Styles.headerDayBudget}>
        <div className={Styles.tag}>
          <div>
            日&nbsp;預&nbsp;算&nbsp;&nbsp;：$
            {(+ad.dayBudget).toLocaleString()}
            /日
          </div>
          <div style={{ visibility: [Statuses.Incomplete, Statuses.Archive, Statuses.Stopped].includes(ad.status) ? 'hidden' : 'default' }}>
            廣告走期：
            {`${ad.startDate.toLocaleDateString()} - ${(ad.endDate === null ? '未指定' : ad.endDate.toLocaleDateString())}`}
          </div>
        </div>
        {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <span className={Styles.numberText}>
            $
            {(+ad.dayBudget).toLocaleString()}
            /
          </span>
          <span className={Styles.dateCharacter}>日</span>
        </div> */}
      </div>
      {/* <div className={Styles.headerStartDay} style={{ visibility: [Statuses.Incomplete, Statuses.Stopped].includes(ad.status) ? 'hidden' : 'default' }}>
        <div className={Styles.tag}>
          廣告走期
        </div>
        <div className={Styles.numberText}>
          {`${ad.startDate.toLocaleDateString()} - ${(ad.endDate === null ? '未指定' : ad.endDate.toLocaleDateString())}`}
        </div>
      </div> */}
      {/* <div
        className={Styles.headerAdState}
      >
        <div className={Styles.tag}>
          單元狀態：
        </div>
        <div className={Styles.adStateText} style={{ color: statusColor || '#ffffff' }}>
          {StatusMessages[ad.status] || '未知'}
        </div>
      </div> */}
      {/* <div className={Styles.headerPadding} style={{ flexShrink: 2 }} /> */}
    </>
  );

  return (
    <div className={Styles.container}>
      {isCollapsed ? isCollapsedRender : isNotCollapsedRender}
    </div>
  );
}

AdSummary.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  isCollapsed: PropTypes.bool,
};

AdSummary.defaultProps = {
  ad: new Ad(),
  isCollapsed: false,
};

export default AdSummary;
